var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0425 4.45475C0.044997 5.03225 -0.296253 6.30725 0.281247 7.3085L6.54375 18.1573C7.12125 19.1548 8.39625 19.4998 9.3975 18.9223L16.6275 14.7448C17.625 14.1673 17.97 12.8923 17.3925 11.891L11.13 1.04225C10.5525 0.0447529 9.27375 -0.296497 8.27625 0.281003L1.0425 4.45475ZM17.2275 15.7835L12.1537 18.7123C12.5175 19.016 12.9862 19.1998 13.5 19.1998H21.9C23.0587 19.1998 24 18.2585 24 17.0998V4.49975C24 3.341 23.0587 2.39975 21.9 2.39975H13.5C13.4325 2.39975 13.3687 2.4035 13.3012 2.40725L18.4312 11.291C19.3387 12.8623 18.7987 14.876 17.2275 15.7835Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicsActiveIcon);
export default __webpack_public_path__ + "static/media/topics-active-icon.7dceecdf5029bf1af3ae832006448036.svg";
export { ForwardRef as ReactComponent };